import { User } from './user';

export class EmployeeActivityModel{
  employeeId: number;
  activity: string;
  note: string;
  activityUser?: User;
  activityDate?: Date;
}